import { useState } from "react";
import WatsonApi from "../backends/WatsonApi";
import { useStores } from "../stores/useStores";

export function useAdaCheckResults() {
  const { organizationStore } = useStores();
  const [adaCheckErrorCount, setAdaCheckErrorCount] = useState<number>(0);
  const [adaCheckResults, setAdaCheckResults] = useState<
    {
      type: string;
      msg: string;
      code: string;
      principle: string;
      techniques: string;
    }[]
  >([]);

  async function checkAda(html: string) {
    const client = await WatsonApi();
    const adaResponse =
      await client.apis.organizations.organizations_ada_evaluate(
        {
          organization_pk: organizationStore.currentOrganization.id,
          accept: "text/html",
        },
        { requestBody: { source: html, output: "json" } },
      );
    const adaResponseParsed = JSON.parse(adaResponse.data);
    const adaCheckResults = adaResponseParsed.slice(
      0,
      adaResponseParsed.length - 1,
    );
    const adaCheckErrorCount =
      adaResponseParsed[adaResponseParsed.length - 1].errorcount;
    setAdaCheckResults(adaCheckResults);
    setAdaCheckErrorCount(adaCheckErrorCount);
    return {
      adaCheckResults,
      adaCheckErrorCount,
    };
  }

  const errorContent =
    adaCheckErrorCount > 0 ? (
      <div className="panel panel-default sb-ada-page-errors-table">
        <div className="panel-heading">
          ADA Compliance Errors
          <span className="label label-danger pull-right">
            {adaCheckErrorCount} errors
          </span>
        </div>
        <div className="panel-body">
          <div className="table-responsive">
            <table id="test-results-table" className="table table-condensed">
              <thead>
                <tr>
                  <th>Message</th>
                  <th>Code Snippet</th>
                  <th>Details</th>
                </tr>
              </thead>
              <tbody>
                {adaCheckResults.map((result, index) => (
                  <tr key={index} className={result.type}>
                    <td className={"messageText"}>{result.msg}</td>
                    <td>
                      <code dangerouslySetInnerHTML={{ __html: result.code }} />
                    </td>
                    <td
                      className={"messageTechniques"}
                      dangerouslySetInnerHTML={{
                        __html: result.principle.replace(
                          />(.*)</,
                          ">Click Here<",
                        ),
                      }}
                    />
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    ) : (
      <></>
    );

  return {
    checkAda,
    adaCheckResults,
    adaCheckErrorCount,
    errorContent,
  };
}
